import { render, staticRenderFns } from "./qxFour.vue?vue&type=template&id=d3daa57a"
import script from "./qxFour.vue?vue&type=script&lang=js"
export * from "./qxFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports